export default __webpack_public_path__ + "static/media/Umberto Tozzi e Di Giacomo.c360762d.jpg";